import { SettingConst } from '@faire/web-api--source/types';

/**
 * Determines what payment method icons to show for each country
 */
export const ADYEN_EU_PAYMENT_METHODS_ICONS =
  'ADYEN_EU_PAYMENT_METHODS_ICONS' as SettingConst<
    'ADYEN_EU_PAYMENT_METHODS_ICONS',
    Array<string>,
    'RETAILER' | 'VISITOR_WEB'
  >;
